<template>
  <div>

    <h1>Associar Menu</h1>

    <div class="container-dados-usuario pb-2 pl-1" v-if="!loadingPerfisMenus && (listaDadosAssociados.length || listaDadosDisponiveis.length)">
      <h5>Perfil: <small> {{ perfilSelecionado.name }}</small></h5>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Menus"
      tituloDisponiveis="Menus"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="perfisParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingPerfisMenus" />
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PerfilMenuAssociacaoPage',

  data () {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created () {
    await this.listarMenus()
    await this.listarMenusPorPerfis(this.$route.params.usuario)
    this.atualizarListaDeDadosAssociadosENaoAssociados()
  },

  watch: {
    perfilSelecionadoComMenus: {
      handler() {
        this.atualizarListaDeDadosAssociadosENaoAssociados()
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters('perfisMenus', ['loadingPerfisMenus', 'listaMenus', 'perfilSelecionado', 'listaMenusPorPerfis']),

    usuarioPerfil() {
      return { perfil: 'Perfil Atual' }
    },
  },

  methods: {
    ...mapActions('usuarios', ['listarUsuarios', 'recuperarUsuario']),
    ...mapActions('perfisMenus', [
      'listarMenus',
      'listarMenusPorPerfis',
      'associarMenuAoPerfil'
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      if (!this.listaMenusPorPerfis || !this.listaMenus) return

      this.listaDadosAssociados = this.listaMenusPorPerfis.map(menu => ({
        id: menu.id,
        descricao: menu.menu,
        selecionado: false,
      }));

      const idsAssociados = this.listaDadosAssociados.map(menu => menu.id);
      this.listaDadosDisponiveis = this.listaMenus
        .filter(menu => !idsAssociados.includes(menu.id))
        .map(menu => ({
          id: menu.id,
          descricao: menu.menu,
          selecionado: false,
        }));
    },

    perfisParaAssociar(value) {
      const menusSelecionados = value.listaAssociados.map(item => item.id);
      const payload = {
        perfilId: this.$route.params.usuario,
        menus: menusSelecionados
      };

      this.associarMenuAoPerfil(payload);
    }
  }
}
</script>
